<template>
  <div class="page-container-summary">
    <LandingBar active="intelligence" />
    <div class="buy-wrapper">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="intelligence-upper">
        <h1 class="table-headline">Pricing Intelligence</h1>
        <!-- <div class="intelligence-graph-full"> -->
        <div class="summary-upper">
          <div class="summary-left">
          <div class="chart-header">Trading Volume</div>
          <div class="pricing-button-inner green-border">
            <v-select
              v-model="selectedZone"
              class="filter-input3"
              label="Zone" id="zone" name="zone"
              hide-details
              color="#58c26d"
              :items="zones"
              item-text="zoneName"
              item-value="zoneCode"
              dense
              outlined
              @change="changeZone()"
            ></v-select>
            <v-select
              v-model="selectedLocation"
              class="filter-input3"
              label="Location" id="location" name="location"
              hide-details
              color="#58c26d"
              :items="locations"
              item-text="locationName"
              item-value="locationCode"
              dense
              outlined
              @change="changeLocation()"
            ></v-select>
            
            <v-select
              v-model="selectedYear"
              class="filter-input3"
              label="Year" id="year" name="year"
              hide-details
              color="#58c26d"
              :items="years"
              item-text="yearName"
              item-value="yearCode"
              dense
              outlined
              @change="changeYear()"
              :hint="`${years.yearCode}`"
            ></v-select>
            <div class="price-reset">Reset filter</div>
          </div>
          <TradingVolumeChart />
          </div>
          <div class="summary-right">
            <div class="chart-header">Total Offers</div>
            <div class="intelligence-graph-half">
              
              <TotalOffersChart />
            </div>
          </div>
        </div>
      </div>
      <div class="summary-upper">
        <div class="intelligence-graph-full">
            <div class="chart-header">Trading Price</div>
          <TradingPriceChart />
        </div>
      </div>
      <!-- <div class="summary-upper">
        <div class="summary-left">
          <div class="intelligence-graph-half">
              <div class="chart-header">Trading Price</div>
            <TradingPriceChart />
          </div>
        </div>
        <div class="summary-right">
          <div class="intelligence-graph-half">
              <div class="chart-header">Total Offers</div>
            <TotalOffersChart />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import LandingBar from "../components/Common/LandingBarTSO.vue";
import TradingVolumeChart from "../components/Charts/TradingVolumeChart";
import SummaryChart from "../components/Charts/SummaryChart";
import TradingPriceChart from "../components/Charts/TradingPriceChart";
import TotalOffersChart from "../components/Charts/TotalOffersChart";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";

import ZoneDataService from "../services/ZoneDataService";
import LocationDataService from "../services/LocationDataService";

const tradingVolumeData = require("../data/trading/tradingVolumeData.json");

export default {
  components: { LandingBar, TradingVolumeChart, SummaryChart, TradingPriceChart, TotalOffersChart },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      bread: [
        {
          text: "Intelligence",
          disabled: false,
        },
        {
          text: "Pricing Intelligence",
          disabled: false,
        },
      ],

      zones: [],
      locations: [],
      years: [
        {
          yearCode:"2022",
          yearName: "2022",
        },
        {
          yearCode:"2021",
          yearName: "2021",
        },
        {
          yearCode:"2020",
          yearName: "2020",
        }
      ],

      selectedZone: null,
      selectedLocation: null,
      selectedYear: null,

      tradingVolume: [],
      totalRequests: 0,
      totalOffers: 0,
      
    };
  },
  methods: {
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },

    retrieveZones() {
      ZoneDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
        .then((response) => {
          this.zones = response.data;
          console.log("HERE... retrieve zones sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve zones error: " + e);
        }); 
    },

    retrieveLocations() {
      LocationDataService.findByCountryCode(this.selectedZone)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... retrieve locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve locations error: " + e);
        }); 
    },

    changeZone() {
      console.log("Selected zone: ", this.selectedZone)
      this.retrieveLocations();
      this.selectedLocation = this.locations[0].locationCode;
      this.getTradingVolumeData(this.selectedZone,this.selectedLocation,this.selectedYear);
      this.$root.$emit("getTradingVolumeData", this.selectedZone,this.selectedLocation,this.selectedYear);
    },

    changeLocation() {
      console.log("Selected location: ", this.selectedLocation)
      this.getTradingVolumeData(this.selectedZone,this.selectedLocation,this.selectedYear);
      this.$root.$emit("getTradingVolumeData", this.selectedZone,this.selectedLocation,this.selectedYear);
    },

    changeYear() {
      console.log("Selected year: ", this.selectedYear)
      this.getTradingVolumeData(this.selectedZone,this.selectedLocation,this.selectedYear);
      this.$root.$emit("getTradingVolumeData", this.selectedZone,this.selectedLocation,this.selectedYear);
    },

    getTradingVolumeData(zoneCode, locationCode, yearCode) {
        //console.log("HERE... consumptions data: " + consumptionsData.toString());
        this.tradingVolume = [];
        this.totalRequests = 0;
        this.totalOffers = 0;
      
        for (var i = 0; i < tradingVolumeData.length; i++) {
            if (tradingVolumeData[i].zoneCode == zoneCode 
                && tradingVolumeData[i].locationCode == locationCode
                && tradingVolumeData[i].yearCode == yearCode) {
              this.tradingVolume.push(tradingVolumeData[i].tradingVolume);
            }
        }
        
        console.log("HERE... trading volume data: " + this.tradingVolume.toString(), "length: " + this.tradingVolume[0].length);

        for (var i = 0; i < this.tradingVolume[0].length; i++) {
          this.totalRequests = this.totalRequests + this.tradingVolume[0][i].totalRequests
          this.totalOffers = this.totalOffers + this.tradingVolume[0][i].totalOffers
        }
        
        console.log("HERE... totalRequests: " + this.totalRequests + " totalOffers: " + this.totalOffers);
    },

  },

  mounted: function () {
    //this.retrieveZones();
    if (this.$store.state.auth.user.countryCode === "BG") {
      this.zones=[
        {
          zoneCode: "BGDSO01",
          zoneName: "CEZ Area",
        }
      ],
      this.selectedZone = "BGDSO01";
      this.selectedLocation = "073"
    } 
    if (this.$store.state.auth.user.countryCode === "TR") { 
      this.zones= [
        {
          zoneCode: "TRDSO16",
          zoneName: "OEDAS - Osmangazi",
        },
      ],
      this.selectedZone = "TRDSO16";
      this.selectedLocation = "228"
    } 
    //console.log("HERE... zones: ", this.zones);
    //console.log("HERE... locations: ", this.locations);
    this.selectedYear = "2021";
    //this.selectedZone = this.zones[0].zoneCode;
    //this.selectedLocation = this.locations[0].locationCode;
    this.retrieveLocations();
    this.$nextTick(function () {
      this.getTradingVolumeData(this.selectedZone,this.selectedLocation,this.selectedYear);
      // Code that will run only after the entire view has been rendered
    });
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;
}

.balance1 {
  flex: 1;
  display: flex;
  padding: 20px;
  position: relative;
  flex-direction: column;
  margin-bottom: 20px;
  border-radius: 10px;
  background: rgba(38, 56, 88, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(38, 56, 88, 1)),
    color-stop(57%, rgba(38, 56, 88, 1)),
    color-stop(75%, rgba(71, 87, 115, 1)),
    color-stop(100%, rgba(153, 164, 180, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#263858', endColorstr='#99a4b4', GradientType=1 );
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.balance {
  margin: 20px 0;
  font-size: 1.3em;
  color: #fff;
  font-weight: 700;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

/* 
.summary-left,
.summary-right {
  width: 48%;
  display: flex;
  flex-direction: column;
} 
*/

.summary-left {
  width: 66%;
  display: flex;
  flex-direction: column;
}

.summary-right {
  width: 30%;
  display: flex;
  flex-direction: column;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.intelligence-upper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.intelligence-graph-full {
  flex: 1;
  width: 100%;
  position: relative;
  background: #fff;
  padding: 20px;
  overflow-x: hidden;
}

.intelligence-graph-half {
  flex: 1;
  width: 100%;
  position: relative;
  background: #fff;
  padding: 20px;
  overflow-x: hidden;
  margin-top: 50px;
}

.chart-header {
  font-weight: 700;
  font-size: 20px;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  padding: 0 20px;
  overflow-x: hidden;
}

.summary-middle-table {
  width: 50%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.buy-wrapper th {
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}

.pricing-button-inner {
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.filter-input3 {
  margin: 5px 25px !important;
  max-width: 200px;
}

.price-reset {
  text-decoration: underline;
  color: #59c26b;
  font-size: 14px;
  margin: 0 25px;
  max-width: 200px;
  cursor: pointer;
}
</style>
